import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/images.css";
import "./styles/no-touch.min.css";
import "./styles/style.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
